import { openMeldRequestContextSchema } from "./profile-identity.js";
import { daemonServiceLaneSchema } from "./service-contract.js";
import { localFolderPathSchema } from "./local-folder-path.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/local-folder-picker.ts
const boundedIdentifierSchema = z$1.string().trim().min(1).max(512);
const LOCAL_FOLDER_PICKER_FRAME_VERSION = 1;
const OPENMELD_LOCAL_FOLDER_PICKER_CAPABILITY_HEADER = "x-openmeld-local-folder-picker-capability";
const LOCAL_FOLDER_PICKER_RUNTIME_CAPABILITY = "local-folder-picker-v1";
const localFolderPickerRuntimeCapabilitySchema = z$1.strictObject({ selectFolders: z$1.literal(true) });
const localFolderPickerPurposeSchema = z$1.enum([
	"computer_file_access",
	"project_connection",
	"agent_profile_working_folder"
]);
const localFolderPickerRequestSchema = z$1.strictObject({
	allowMultiple: z$1.boolean(),
	expectedDeviceId: boundedIdentifierSchema,
	purpose: localFolderPickerPurposeSchema
});
const localFolderPickerErrorCodeSchema = z$1.enum([
	"local.folder_picker.device_mismatch",
	"local.folder_picker.helper_missing",
	"local.folder_picker.internal_error",
	"local.folder_picker.invalid_request",
	"local.folder_picker.invalid_response",
	"local.folder_picker.no_interactive_session",
	"local.folder_picker.picker_busy",
	"local.folder_picker.portal_unavailable",
	"local.folder_picker.service_offline",
	"local.folder_picker.service_update_required",
	"local.folder_picker.timed_out",
	"local.folder_picker.unsupported_platform"
]);
const localFolderPickerHelperErrorCodeSchema = z$1.enum([
	"local.folder_picker.internal_error",
	"local.folder_picker.invalid_response",
	"local.folder_picker.no_interactive_session",
	"local.folder_picker.portal_unavailable",
	"local.folder_picker.timed_out",
	"local.folder_picker.unsupported_platform"
]);
const localFolderPickerHelperSelectedResultSchema = z$1.strictObject({
	paths: z$1.array(localFolderPathSchema).min(1).max(128),
	status: z$1.literal("selected")
});
const localFolderPickerHelperCancelledResultSchema = z$1.strictObject({ status: z$1.literal("cancelled") });
const localFolderPickerHelperUnavailableResultSchema = z$1.strictObject({
	code: localFolderPickerHelperErrorCodeSchema,
	status: z$1.literal("unavailable")
});
const localFolderPickerHelperResultSchema = z$1.discriminatedUnion("status", [
	localFolderPickerHelperSelectedResultSchema,
	localFolderPickerHelperCancelledResultSchema,
	localFolderPickerHelperUnavailableResultSchema
]);
const localFolderPickerHelperProtocolResultSchema = z$1.discriminatedUnion("status", [
	localFolderPickerHelperSelectedResultSchema.extend({ v: z$1.literal(LOCAL_FOLDER_PICKER_FRAME_VERSION) }),
	localFolderPickerHelperCancelledResultSchema.extend({ v: z$1.literal(LOCAL_FOLDER_PICKER_FRAME_VERSION) }),
	localFolderPickerHelperUnavailableResultSchema.extend({ v: z$1.literal(LOCAL_FOLDER_PICKER_FRAME_VERSION) })
]);
const localFolderPickerSelectedResultSchema = z$1.strictObject({
	deviceId: boundedIdentifierSchema,
	paths: z$1.array(localFolderPathSchema).min(1).max(128),
	status: z$1.literal("selected")
});
const localFolderPickerCancelledResultSchema = z$1.strictObject({
	deviceId: boundedIdentifierSchema,
	status: z$1.literal("cancelled")
});
const localFolderPickerUnavailableResultSchema = z$1.strictObject({
	code: localFolderPickerErrorCodeSchema,
	message: z$1.string().trim().min(1).max(1024),
	status: z$1.literal("unavailable")
});
const localFolderPickerResultSchema = z$1.discriminatedUnion("status", [
	localFolderPickerSelectedResultSchema,
	localFolderPickerCancelledResultSchema,
	localFolderPickerUnavailableResultSchema
]);
const localFolderPickerRpcInputSchema = localFolderPickerRequestSchema.extend({ context: openMeldRequestContextSchema });
const localFolderPickerRequestFrameSchema = z$1.strictObject({
	code: z$1.literal("daemon.local_folder_picker.select_folders"),
	payload: z$1.strictObject({
		request: localFolderPickerRequestSchema,
		requestId: boundedIdentifierSchema
	}),
	v: z$1.literal(LOCAL_FOLDER_PICKER_FRAME_VERSION)
});
const localFolderPickerResultFrameSchema = z$1.strictObject({
	code: z$1.literal("daemon.local_folder_picker.select_folders_result"),
	payload: z$1.strictObject({
		requestId: boundedIdentifierSchema,
		result: localFolderPickerResultSchema
	}),
	v: z$1.literal(LOCAL_FOLDER_PICKER_FRAME_VERSION)
});
const localFolderPickerDaemonFrameSchema = z$1.discriminatedUnion("code", [localFolderPickerRequestFrameSchema, localFolderPickerResultFrameSchema]);
const runtimeTransportLocalFolderPickerRequestSchema = z$1.strictObject({
	deviceId: boundedIdentifierSchema,
	lane: daemonServiceLaneSchema,
	ownerUserId: boundedIdentifierSchema,
	request: localFolderPickerRequestSchema,
	requestId: boundedIdentifierSchema,
	v: z$1.literal(LOCAL_FOLDER_PICKER_FRAME_VERSION)
});
//#endregion
export { LOCAL_FOLDER_PICKER_RUNTIME_CAPABILITY, OPENMELD_LOCAL_FOLDER_PICKER_CAPABILITY_HEADER, localFolderPickerCancelledResultSchema, localFolderPickerDaemonFrameSchema, localFolderPickerErrorCodeSchema, localFolderPickerHelperErrorCodeSchema, localFolderPickerHelperProtocolResultSchema, localFolderPickerHelperResultSchema, localFolderPickerPurposeSchema, localFolderPickerRequestFrameSchema, localFolderPickerRequestSchema, localFolderPickerResultFrameSchema, localFolderPickerResultSchema, localFolderPickerRpcInputSchema, localFolderPickerRuntimeCapabilitySchema, localFolderPickerSelectedResultSchema, localFolderPickerUnavailableResultSchema, runtimeTransportLocalFolderPickerRequestSchema };

//# sourceMappingURL=local-folder-picker.js.map